import { IUserProfile } from '../../models/IUserProfile';
import {
  // IReceiveUserImpersonationAction,
  // IRequestUserImpersonationAction,
  ISetUserImpersonationAction,
  UserImpersonationActionTypes,
} from '../action-types/userImpersonationActionTypes';

// export function requestUserImpersonation(): IRequestUserImpersonationAction {
//     return {
//         type: UserImpersonationActionTypes.REQUEST_IMPERSONATION,
//     };
// }

// export function receiveUserImpersonation(
//     userProfile: IUserProfile
// ): IReceiveUserImpersonationAction {
//     return {
//         type: UserImpersonationActionTypes.RECEIVE_IMPERSONATION,
//         userProfile,
//     };
// }

export function setUserImpersonation(value: IUserProfile): ISetUserImpersonationAction {
  return {
    type: UserImpersonationActionTypes.SET_IMPERSONATION,
    allowedImpersonation: value.allowedImpersonation,
    companyCode: value.companyCode,
    allowedAva: value.allowedAva,
    alias: value.alias,
    costCenter: value.costCenter,
  };
}
